import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";
import Edit from "./view/edit";
import Organize from "./organize";

const CareerPathEditor = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/organize" element={<Organize />} />
      <Route path="/:id" element={<View />} />
      <Route path="/:id/edit" element={<Edit />} />
    </Routes>
  );
};

export default CareerPathEditor;
